import { lazy } from "react";

export { RequireAdmin, RequireAuth } from "./ui/guards";
export { useSession, useLogout, fetchSession } from "./api/session";
export { safeNext } from "./model/safe-next";

// Forms pull in react-hook-form and zod; load them only on the pages that show them.
export const LoginForm = lazy(() =>
  import("./ui/LoginForm").then((m) => ({ default: m.LoginForm })),
);
export { ZohoSignIn } from "./ui/ZohoSignIn";
export { useZohoFinish } from "./api/session";
export { forgetZohoVerifier, takeZohoVerifier } from "./model/zoho-verifier";
export const ChangePasswordForm = lazy(() =>
  import("./ui/ChangePasswordForm").then((m) => ({ default: m.ChangePasswordForm })),
);
